module.exports = __webpack_public_path__ + "img/logo.d51fb6a.svg";